import { TrustpilotBanner } from '@ecomm/shared-components/lib/TrustpilotBanner'
import {
  trustPilotUKHomePageCarousel,
  trustPilotUKPageTopBanner,
  trustPilotUKReviewPageCarousel
} from '@ecomm/shared-components/lib/TrustpilotBanner/configurations'
import { TrustpilotUKTopBanner } from '@ecomm/shared-components/lib/TrustpilotTopBanner'
import type { TrustPilot } from '@ecomm/shared-data'
import classNames from 'classnames'

type Props = {
  readonly type: TrustPilot['type']
  readonly className?: string
}

//This component is temporary to speed up things, but it will be deleted
//and all the logic of the type field will be placed on the shared trustpilot banner in other PR
const widgets = {
  'Home Page Carousel': trustPilotUKHomePageCarousel,
  'Top Banner': trustPilotUKPageTopBanner,
  'Reviews Page Carousel': trustPilotUKReviewPageCarousel
}
export function TrustPilot({ type, className = '' }: Props) {
  const widget = widgets[type]
  return widget ? (
    type === 'Top Banner' ? (
      <TrustpilotUKTopBanner />
    ) : (
      <TrustpilotBanner
        className={classNames(
          '-mb-4 mt-6 md:-mb-6 md:mt-8 lg:mt-12',
          className
        )}
        widget={widget}
      />
    )
  ) : null
}
